import { Box } from '@mui/material';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { Close } from '@HomaHealth/ui-component-library';

interface ModalTitleBarProps {
  handleClose: () => void;
}

export const ModalTitleBar = ({ handleClose }: ModalTitleBarProps) => {
  const messages = componentConstants.ORGANISMS.COHORT_DETAILS;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          fontSize="18px"
          lineHeight="26px"
          fontType="medium"
          textColor={patientAccessTheme.palette.text.highemphasis}
          margin="0px 0px 4px 0px"
        >
          {messages.DETAILS}
        </Typography>
        <Typography
          fontSize="14px"
          fontType="regular"
          lineHeight="25px"
          textColor={patientAccessTheme.palette.text.mediumemphasis}
          margin="0px 0px 4px 0px"
        >
          {messages.SUB_TITLE}
        </Typography>
      </Box>
      <Box>
        <Close
          height={'14px'}
          width={'14px'}
          fill={patientAccessTheme.palette.status.icon}
          onClick={handleClose}
          cursor={'pointer'}
        />
      </Box>
    </Box>
  );
};
